import { Injectable } from '@angular/core';
import { AuthenticationToken } from '@core/authentication/authentication-token';
import { AssetClassValueObject } from '@core/models/asset-class-value-object';
import { Company } from '@core/models/company.model';
import { NotificationsCounters } from '@core/models/notification.model';
import { Privileges } from '@core/models/privileges.model';
import { UserOverview } from '@core/models/user-overview.model';
import { User } from '@core/models/user.model';
import { ValueObject } from '@core/models/value-object.model';
import { ListViewType } from '@core/views/list-view-type';
import { ViewType } from '@core/views/view-type';
import { Store, StoreConfig } from '@datorama/akita';

import { UserDetails } from '../models/user-details.model';
import { UserProfile } from '../models/user-profile.model';

export type DetailContext = 'product' | 'issuing' | 'issuing-process';

export interface AppState {
  authentication: AuthenticationToken;
  availableAssetClasses: AssetClassValueObject[];
  availableCompanies: Company[];
  availableCountries: ValueObject[];
  availableEsgComplianceOptions: ValueObject[];
  availableIndustries: ValueObject[];
  availableInvestorClasses: ValueObject[];
  availableClientClasses: ValueObject[];
  availableLanguages: ValueObject[];
  availableRatings: ValueObject[];
  availableSalutations: ValueObject[];
  availableTitles: ValueObject[];
  availableOccupations: ValueObject[];
  availableBusinessTypes: ValueObject[];
  availableMainSourceOfFunds: ValueObject[];
  currentDetailContext: DetailContext;
  currentProductNdaRequirement: boolean;
  currentReturnUrl: string;
  currentRoute: string[];
  listViewType: ListViewType;
  notificationsCounters: NotificationsCounters;
  privileges: Privileges;
  user: User;
  userDetails: UserDetails;
  userProfile: UserProfile;
  usersOverview: UserOverview[];
  viewType: ViewType;
  isPartnerScreen : boolean;
}

export function createInitialState(): AppState {
  return {
    authentication: {
      token: null,
      expiry: null,
    },
    availableAssetClasses: null,
    availableCompanies: null,
    availableCountries: null,
    availableEsgComplianceOptions: null,
    availableIndustries: null,
    availableInvestorClasses: null,
    availableClientClasses: null,
    availableLanguages: null,
    availableRatings: null,
    availableSalutations: null,
    availableTitles: null,
    availableOccupations: null,
    availableBusinessTypes: null,
    availableMainSourceOfFunds: null,
    currentDetailContext: null,
    currentProductNdaRequirement: null,
    currentReturnUrl: null,
    currentRoute: null,
    listViewType: 'grid',
    notificationsCounters: {
      unreadCount: 0,
    },
    privileges: null,
    user: null,
    userDetails: null,
    userProfile: null,
    usersOverview: null,
    viewType: 'default',
    isPartnerScreen : false
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'AppStore', resettable: true })
export class AppStore extends Store<AppState> {
  constructor() {
    super(createInitialState());
  }
}
